// TODO: switch back to lbprod on build
export const API_DOMAIN_PROD = 'https://lbprod.yapmap.app/v1'
export const API_DOMAIN = 'https://preprod.yapmap.app/v1'
// export const API_DOMAIN = 'http://localhost:5110'
